import { useEffect } from 'react'
import { useLocation, useMatch } from 'react-router-dom'
import { ERoutes } from 'common/entities/routes'
import { sendPageViewEvent } from 'common/utils/data-layer'

export const usePageView = () => {
  const routerLocation = useLocation()
  const matchOnboarding = useMatch(ERoutes.ONBOARDING)

  useEffect(() => {
    sendPageViewEvent(window.location.href, { inRegister: !!matchOnboarding })
  }, [routerLocation, matchOnboarding])
}
